import { DragOverlay, defaultDropAnimationSideEffects, type DropAnimation } from '@dnd-kit/core';
import { restrictToParentElement } from '@dnd-kit/modifiers';
import React, { type PropsWithChildren } from 'react';

const dropAnimationConfig: DropAnimation = {
    sideEffects: defaultDropAnimationSideEffects({
        className: {
            dragOverlay: 'drag-overlay',
        },
        styles: {
            active: {
                opacity: '0',
            },
        },
    }),
};

export function SortableOverlay({ children }: PropsWithChildren<object>) {
    return (
        <DragOverlay
            zIndex={1001}
            modifiers={[restrictToParentElement]}
            dropAnimation={dropAnimationConfig}
            className={children !== null ? 'dragged' : undefined}
        >
            {children}
        </DragOverlay>
    );
}
